import BannerAward2024 from '../img/banner/Award2024.png';
import section1 from '../img/event/2601/main.png';
import Online_Session from '../img/event/2601/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import { TextBox } from './common/TextBox';
const HomeschoolEvent202601 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />
      {/* 프로모션 섹션 1 */}
      <img src={section1} alt="2026 젭스영어교실" />

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FFEEDD]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-5 px-5 py-10 sm:gap-12 sm:py-20">
          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-lg font-semibold text-black sm:text-2xl">
                젭스영어교실의
                <br /> 비전, 커리큘럼, 이용 방법이 궁금하시다면?
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-xl font-extrabold text-[#FF7700] sm:text-3xl">
                온라인 설명회에서 자세히 알려드립니다!
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어교실 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex items-center justify-center bg-[#FF7700]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          {/* 타이틀 영역 */}
          <div className="flex flex-col items-center justify-center gap-5">
            {/* 타이틀 */}
            <p className="text-center text-2xl font-extrabold text-[#FFEEDD] sm:text-4xl">
              젭스영어교실 신청 시,
              <br /> 수업 콘텐츠부터 디자인 자료
              <br /> 믿음의 커뮤니티까지!
            </p>
            {/* 서브타이틀 */}
            <p className="text-md text-center font-medium text-white sm:text-2xl">
              젭스영어교실은
              <br />
              성경스토리 → 청크 학습 → 스피킹 → 발표까지
              <br /> 한 달에 교재 1세트로 완성되는 프로그램입니다
            </p>
          </div>
          {/* 박스 */}
          <section className="flex w-full flex-col gap-5 sm:gap-8">
            <div className="grid auto-rows-fr grid-cols-1 gap-5">
              <TextBox className="h-full">
                <p className="text-xl font-extrabold text-black md:text-3xl">
                  청크로 배우는{' '}
                  <span className="text-[#FF7700]">말문이 터지는 영어</span>
                </p>
              </TextBox>
              <TextBox className="h-full">
                <p className="text-xl font-extrabold text-[#FF7700] md:text-3xl">
                  발명특허 받은 교수법으로
                  <br />
                  <span className="text-black">
                    성경 스토리를 확실하게 암송
                  </span>
                </p>
              </TextBox>
              <TextBox className="h-full">
                <p className="text-xl font-extrabold text-[#FF7700] md:text-3xl">
                  스토리텔링 & 발표 학습
                </p>
              </TextBox>
            </div>
          </section>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
              1월 등록 혜택 확인
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202601;
